import { cn } from '@utils/cn';
import { type ComponentRef, forwardRef } from 'react';

import { type SkeletonProps } from './types';

const Skeleton = forwardRef<ComponentRef<'div'>, SkeletonProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('animate-pulse rounded-md bg-muted', className)}
        aria-label="Cargando..."
        {...props}
      />
    );
  },
);

Skeleton.displayName = 'Skeleton';

export { Skeleton };
